import { createContext, useContext, useMemo, type ReactNode } from 'react';

import { useCloudSynced } from '@/hooks';
import { EMPTY_NAME, parseName, resolveName, type ProfileName } from '@/name';
import { FIRST_NAME, LAST_NAME } from '@/tgUser';

const KEY = 'profile_name';

interface ProfileNameState {
  stored: ProfileName;
  name: ProfileName;
  set: (value: ProfileName) => void;
}

const Ctx = createContext<ProfileNameState>({
  stored: EMPTY_NAME,
  name: EMPTY_NAME,
  set: () => {},
});

export function ProfileNameProvider({ children }: { children: ReactNode }) {
  const [stored, setStored] = useCloudSynced<ProfileName>(KEY, parseName, EMPTY_NAME, (v) =>
    JSON.stringify(v),
  );

  const value = useMemo(
    () => ({
      stored,
      name: resolveName(stored, { first: FIRST_NAME, last: LAST_NAME }),
      set: setStored,
    }),
    [stored, setStored],
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useProfileName(): ProfileNameState {
  return useContext(Ctx);
}
